// extracted by mini-css-extract-plugin
export default {"main":"Laa-z"};